import CaseStudiesSection from "@/components/CaseStudiesSection";
import Testimonials from "@/components/Testimonials";
import CTASection from "@/components/CTASection";
import PageHeader from "@/components/PageHeader";

export default function CaseStudiesPage() {
  return (
    <>
      <PageHeader
        eyebrow="/ Case studies"
        title={<>Platforms we've shipped. <span className="text-gradient">Numbers we've moved.</span></>}
        copy="A sample of recent engagements across healthcare, retail and SaaS — anonymized to protect client confidentiality."
      />
      <CaseStudiesSection />
      <Testimonials />
      <CTASection />
    </>
  );
}
